'use client';

import { __assign } from '../_virtual/_tslib.js';
import React__default, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import closeIcon from './deleteIcon.js';
import styles from './Modal.module.css.js';

var Modal = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, isBlank = props.isBlank, _b = props.onBack, onBack = _b === void 0 ? function () { } : _b, title = props.title, zIndex = props.zIndex, headerRight = props.headerRight, width = props.width, _c = props.fullHeight, fullHeight = _c === void 0 ? true : _c, _d = props.backdrop, backdrop = _d === void 0 ? true : _d, onClickOutside = props.onClickOutside, footerNode = props.footerNode, position = props.position, styleBody = props.styleBody, customModal = props.customModal, _e = props.containerStyle, containerStyle = _e === void 0 ? {} : _e, _f = props.bodyStyle, bodyStyle = _f === void 0 ? {} : _f, _g = props.children, children = _g === void 0 ? null : _g, bottomText = props.bottomText;
    var containerRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (e) {
            var _a;
            var isClickOutside = !((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target));
            if (isClickOutside && onClickOutside) {
                onClickOutside();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    /**
     * In Server side rendering case, document will be undefined
     */
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    var classOpen = isOpen ? styles.isOpen : '';
    var modalStyle = {};
    if (width) {
        modalStyle.width = width;
    }
    if (zIndex) {
        modalStyle.zIndex = zIndex;
    }
    var backdropStyle = {};
    if (zIndex) {
        backdropStyle.zIndex = zIndex - 1;
    }
    return ReactDOM.createPortal(React__default.createElement("div", null,
        backdrop && React__default.createElement("div", { style: backdropStyle, className: "".concat(styles.backdrop, " ").concat(classOpen) }),
        React__default.createElement("div", { className: "".concat(styles.container, " ").concat(classOpen, " ").concat(position || '', " ").concat(customModal || '', " ").concat(fullHeight ? styles.fullHeight : ''), style: __assign(__assign({}, modalStyle), containerStyle), ref: containerRef }, isBlank ? (React__default.createElement("div", null,
            React__default.createElement("span", { onClick: onBack, className: "".concat(styles.icon, " ").concat(styles.closeIcon) },
                React__default.createElement(closeIcon, null)),
            React__default.createElement("div", { className: "".concat(styles.body || '', " ").concat(styleBody || '') }, children))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("div", { className: styles.header },
                React__default.createElement("span", { onClick: onBack, className: "".concat(styles.icon, " ").concat(styles.left) },
                    React__default.createElement(closeIcon, null)),
                React__default.createElement("div", { className: styles.title }, title),
                React__default.createElement("div", { className: "".concat(styles.right) }, headerRight || null)),
            React__default.createElement("div", { className: styles.body, style: bodyStyle }, children),
            bottomText,
            footerNode && React__default.createElement("div", { className: styles.footer }, footerNode))))), bodyNode);
};

export { Modal as default };
//# sourceMappingURL=index.js.map
